import { render, staticRenderFns } from "./landing-public-product-search.vue?vue&type=template&id=6b7c96c4&scoped=true&lang=pug"
import script from "./landing-public-product-search.js?vue&type=script&lang=js&external"
export * from "./landing-public-product-search.js?vue&type=script&lang=js&external"
import style0 from "./landing-public-product-search.vue?vue&type=style&index=0&id=6b7c96c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7c96c4",
  null
  
)

export default component.exports